import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-left\"><path fill-rule=\"evenodd\" d=\"M17 5.026V3.19c0-.159-.194-.247-.325-.15L5.31 11.404A.742.742 0 005 12c0 .233.114.454.31.597l11.365 8.362c.133.098.325.01.325-.15v-1.835a.376.376 0 00-.154-.3l-9.075-6.673 9.075-6.676A.376.376 0 0017 5.026z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol